/*
 * @Author: gongzhichao 18311120024@163.com
 * @Date: 2023-05-25 19:05:44
 * @LastEditors: gongzhichao 18311120024@163.com
 * @LastEditTime: 2024-03-19 17:44:38
 * @FilePath: \jyrg-web\src\api\webSite.js
 * @Description: 接口文件
 */
import request from "@/request/request";
// const urls = {
//   getOrderNum:"/api/phoneOrder/getOrderNum",
//   getAllNews: "/api/publicsrc/searchAllNews",
//   searchOthers: "/api/publicsrc/searchOthersOne",
//   searchFooter: "/api/publicsrc/searchFooterOne",
//   searchNewsById: "/api/publicsrc/searchNewsById",
//   searchStrategy: "/api/publicsrc/searchStrategy",
//   searchGameData: "/api/publicsrc/searchGameData",
//  searchLatestNews: "/api/publicsrc/searchLatestNews",
//   searchHeadTitles: "/api/publicsrc/searchHeadTitles",
//   getContactInfo: "/api/publicsrc/searchAllAtlas",
//   getActivityImg: "/api/publicsrc/searchThreeNews",
//   getDownloadUrl: "/api/publicsrc/searchDownloadUrl",
//   uploadFile:"/api/oss/v1/upload",
//   addUploadFile: "/api/image/v1/upload",
//   getUploadImages: "/api/image/v1/query",
//   getCopywriting: "/api/image/v1/queryCopywriting",  
//   setOcpcAccess: "/api/ocpc/access",
//   setDownload: "/api/statistics/download",
//   loadSmsCode: "/api/sms/loadSmsCode",
//   orderLogin: "/api/order/user/login",

// };


const urls = {
  getOrderNum:"/backend/api/phoneOrder/getOrderNum",
  getAllNews: "/backend/api/publicsrc/searchAllNews",
  searchOthers: "/backend/api/publicsrc/searchOthersOne",
  searchFooter: "/backend/api/publicsrc/searchFooterOne",
  searchNewsById: "/backend/api/publicsrc/searchNewsById",
  searchStrategy: "/backend/api/publicsrc/searchStrategy",
  searchGameData: "/backend/api/publicsrc/searchGameData",
  searchLatestNews: "/backend/api/publicsrc/searchLatestNews",
  searchHeadTitles: "/backend/api/publicsrc/searchHeadTitles",
  getContactInfo: "/backend/api/publicsrc/searchAllAtlas",
  getActivityImg: "/backend/api/publicsrc/searchThreeNews",
  getDownloadUrl: "/backend/api/publicsrc/searchDownloadUrl",
  uploadFile:"/backend/api/oss/v1/upload",
  addUploadFile: "/backend/api/image/v1/upload",
  getUploadImages: "/backend/api/image/v1/query",
  getCopywriting: "/backend/api/image/v1/queryCopywriting",
  setOcpcAccess: "/backend/api/ocpc/access",
  setDownload: "/backend/api/statistics/download",
  loadSmsCode: "/backend/api/sms/loadSmsCode",
  orderLogin: "/backend/api/order/user/login",

};

const webSite = {
  getOrderNum:()=>{
    return request({ url:urls.getOrderNum, method:"get" })
  },
  getAllNews: (newsType) => {
    return request(
      { url: urls.getAllNews,
         method: "get",
         params: {
          "newsType": newsType,
      }
      
       });
  },

  searchOthers: (params) => {
    return request({ url: urls.searchOthers, method: "post", data: { ...params } });
  },

  searchFooter: (params) => {
    return request({ url: urls.searchFooter, method: "post", data: { ...params } });
  },

  searchNewsById: (params) => {
    return request({ url: urls.searchNewsById, method: "post", data: { ...params } });
  },

  searchStrategy: () => {
    return request({ url: urls.searchStrategy, method: "get" });
  },


  searchGameData: (gameDataType) => {
    return request(
      { url: urls.searchGameData,
         method: "get",
         params: {
          "gameDataType": gameDataType,
      }

       });
  },
  searchHeadTitles: () => {
    return request({ url: urls.searchHeadTitles, method: "get" });
  },

  getContactInfo: () => {
    return request({ url: urls.getContactInfo, method: "get" });
  },

  getActivityImg: () => {
    return request({ url: urls.getActivityImg, method: "get" });
  },

  getDownloadUrl: () => {
    return request({ url: urls.getDownloadUrl, method: "get" });
  },

  uploadFile: (params) => {
    return request({ 
      url: urls.uploadFile, 
      method: "post", 
      params
    });
  },
  addUploadFile: (params) => {
    return request({ 
      url: urls.addUploadFile, 
      method: "post", 
      data: { ...params } 
    });
  },
  getUploadImages: (params) => {
    return request({ 
      url: urls.getUploadImages, 
      method: "post", 
      data: { ...params } 
    });
  },
  getCopywriting: () => {
    return request({ 
      url: urls.getCopywriting, 
      method: "post", 
    
    });
  },
  setOcpcAccess: (params) => {
    return request({ 
      url: urls.setOcpcAccess, 
      method: "post", 
      data: { ...params } 
    });
  },

  setDownload(osType, bdVid) {
    return request({
        url: urls.setDownload, 
        method: 'get',
        params: {
            "bdVid": bdVid,
            "osType": osType
        }
    })

  },

  //临时登录
  
  loadSmsCode: (params) => {
    return request({ 
      url: urls.loadSmsCode, 
      method: "post", 
      data: { ...params } 
    });
  },

    searchLatestNews: (newsType) => {
      return request(
        { url: urls.searchLatestNews,
           method: "get",
           params: {
            "newsType": newsType,
        }
        
  
         });
    },
    //内部验证登录
    orderLogin: (params) => {
      return request({ 
        url: urls.orderLogin, 
        method: "post", 
        data: { ...params } 
      });
    },

};


export default webSite;
